/**
 * Identyfikator do cancel'a dla
 */
export default class DceWebSocketSubscribeHandle {
    private _id:number;
    constructor(id: number) {
        this._id = id;
    }
    get id(): number {
        return this._id;
    }
}